export const scrollChipMixin = {
	data() {
		return {
			scrollRightStop: false,
			maxTranslateX: 0,
			translateX: 0,
			rightPadding: 0,
		}
	},
	methods: {
		getChipName(chipItem) {
			return this.useContentAsKey ? chipItem.content : chipItem.name
		},
		getChipLabel(chipItem) {
			return this.useContentAsKey ? chipItem.name : chipItem.content
		},
		resetScroll() {
			this.translateX = 0
			this.scrollRightStop = false
			this.rightPadding = 0
		},
		moveLeft() {
			this.translateX = Math.min(0, this.translateX + 100)
			this.rightPadding = 0
			this.updateScrollState()
		},
		moveRight() {
			const scrollStep = 100
			this.translateX = Math.max(-this.maxScrollWidth - 10, this.translateX - scrollStep)

			if (this.translateX <= -this.maxScrollWidth) {
				this.rightPadding = 10
			} else {
				this.rightPadding = 0
			}

			this.updateScrollState()
		},
		updateScrollState() {
			this.scrollRightStop = this.translateX <= -this.maxScrollWidth - 10
		},
		handleResize() {
			this.translateX = Math.max(-this.maxScrollWidth, this.translateX)
			this.updateScrollState()
		},
	},
	computed: {
		maxScrollWidth() {
			if (!this.$refs.scrollContainer) return 0
			const containerWidth = this.$refs.scrollContainer.offsetWidth
			const contentWidth = this.$refs.scrollContainer.scrollWidth
			return Math.max(0, contentWidth - containerWidth + this.rightPadding + 20)
		},
		needScroll() {
			return this.normalizedFeedFilterChips.length > 5
		},
		canScrollLeft() {
			return this.translateX < 0
		},
	},
	mounted() {
		window.addEventListener('resize', this.handleResize)
		this.$nextTick(this.updateScrollState)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize)
	},
	watch: {
		$route() {
			this.resetScroll()
		},
	},
}
